import { ProductsEtaContext } from '@app/components/products/ProductsEta';
import { ProductBadge } from '@app/components/various/ProductBadge';
import { useProductBadges } from '@app/utils/hooks/useProductBadges';
import { Product } from '@typings';
import React from 'react';

interface Props {
  activeVariant: Product.Standard;
}

export const ProductDetailsBadges = ({ activeVariant }: Props) => {
  const { currentStockTypeDelwinIds } = React.useContext(ProductsEtaContext);

  const { defaultBadges, customBadges } = useProductBadges({
    areAllRelationsUnavailable: false,
    delwinIds: currentStockTypeDelwinIds,
    isVariantAvailable: true,
    variant: activeVariant,
  });

  const badges = [...defaultBadges, ...customBadges];

  if (badges.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1 sm:-mb-3 sm:gap-2 lg:gap-x-4">
      {badges.map((badge, index) => (
        <ProductBadge key={index} badge={badge} size="small" />
      ))}
    </div>
  );
};
